if (!customElements.get('logo-banner')) {
    class LogoBanner extends HTMLElement {
        constructor() {
            super();
            this.initSwiper();
        }

        initSwiper() {
            const logoSwiper = new Swiper('[data-swiper-id="logos"]', {
                slidesPerView: 'auto',
                spaceBetween: 30,
                loop: true,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                },
                speed: 3000,
            }) 
        }
    }

    customElements.define('logo-banner', LogoBanner);
}